import SeeDetailsPage from './SeeDetailsPage';

export default SeeDetailsPage;
